export default __webpack_public_path__ + "static/media/token-2.8ed4699b.png";